import React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box, Chip } from "@mui/material";
import { Link } from "react-router-dom";

const ExploreGrid = ({ rows, showKnownSince = false }) => {

    const columns = [
        {
            field: "username",
            headerName: "Name",
            flex: 2.2,
            renderCell: (params) => (
                <Link
                    to={`/user/findcontact/${params.row.journeyRoute}/${params.row.tagId}/${params.row.external_id}?name=${encodeURIComponent(params.value)}`}
                    target="_blank"
                    style={{ textDecoration: "none" }}
                >
                    <Box
                        sx={{
                            color: "#1565C0",
                            px: 2,
                            py: 0.6,
                            borderRadius: "8px",
                            fontWeight: 600,
                            display: "inline-block",
                            transition: "0.2s",
                        }}
                    >
                        {params.value}
                    </Box>
                </Link>
            ),
        },
        {
            field: "engagement_score",
            headerName: "Engagement",
            flex: 1,
            renderCell: (params) => (
                <Chip
                    label={params.value}
                    size="small"
                    color={
                        params.value >= 500
                            ? "success"
                            : params.value >= 200
                            ? "warning"
                            : "default"
                    }
                />
            ),
        },
        {
            field: "interaction_count",
            headerName: "Interactions",
            flex: 1,
        },
        {
            field: "customer_views",
            headerName: "Views",
            flex: 1,
        },
        {
            field: showKnownSince ? "known_since" : "update_date",
            headerName: showKnownSince ? "Known Since" : "Last Contact",
            flex: 1.5,
            valueFormatter: ({ value }) =>
                value
                    ? new Date(value).toLocaleDateString("en-GB")
                    : "No Data",
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1.5,
            renderCell: (params) => {

                const colorMap = {
                    "Recently Engaged": "success",
                    "Follow Up Soon": "warning",
                    "Attention Needed": "warning",
                    "Critical": "error",
                };

                return (
                    <Chip
                        label={params.value}
                        color={colorMap[params.value] || "default"}
                        size="small"
                    />
                );
            },
        }
    ];

    return (
        <DataGrid
            autoHeight
            rows={rows}
            columns={columns}
            getRowClassName={(params) => {
                switch (params.row.status) {
                    case "Recently Engaged":
                        return "row-green";

                    case "Follow Up Soon":
                        return "row-yellow";

                    case "Attention Needed":
                        return "row-orange";

                    case "Critical":
                        return "row-red";

                    default:
                        return "";
                }
            }}
            sx={{
                "& .row-green": {
                    backgroundColor: "#E8F5E9",
                },

                "& .row-yellow": {
                    backgroundColor: "#FFF8E1",
                },

                "& .row-orange": {
                    backgroundColor: "#FFF3E0",
                },

                "& .row-red": {
                    backgroundColor: "#FDECEC",
                },

                "& .MuiDataGrid-row:hover": {
                    backgroundColor: "inherit !important",
                },
            }}
            pageSizeOptions={[10,25,50,100]}
            rowHeight={60}
            disableRowSelectionOnClick
            slots={{
                toolbar: GridToolbar,
            }}
            initialState={{
                pagination:{
                    paginationModel:{
                        pageSize:10,
                    },
                },
            }}
        />
    );
};

export default ExploreGrid;